import React from "react";
import ReactMarkdown from "react-markdown";
import styles from "./IndexingViewer.module.css";
import uiStyles from "../../reportViewers/ReportUIPrimitives.module.css";
import { renderParagraphs } from "./utils.jsx";

const parseSummaryLines = (markdown = "") => {
  const match = String(markdown || "").match(/Summary:\s*([\s\S]*)$/i);
  if (!match) return [];
  return String(match[1] || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => line.replace(/^[-\u2022]\s*/, ""))
    .filter((line) => !/^\*\*.*assessment.*\*\*$/i.test(line));
};

const IndexingAssessmentViewerV2 = ({ markdown }) => {
  if (!markdown) return null;
  const summaryLines = parseSummaryLines(markdown);

  return (
    <div className={styles.card}>
      <div className={styles.hero}>
        <div className={styles.heroLeft}>
          <div className={styles.heroIcon} aria-hidden="true">
            <span className={styles.heroGlass} />
          </div>
          <div>
            <h4 className={styles.heroTitle}>Indexing Coverage</h4>
          </div>
        </div>
        <p className={styles.heroSubtitle}>
          Coverage insights from Google Search Console
        </p>
      </div>

      {summaryLines.length > 0 ? (
        <div className={styles.sectionCard}>
          <div className={styles.sectionHeader}>Summary</div>
          <div className={styles.summaryBody}>
            {summaryLines.map((line, idx) => (
              <div key={`summary-${idx}`} className={styles.summaryRow}>
                <span className={uiStyles.summaryCheck} aria-hidden="true" />
                <ReactMarkdown
                  components={{
                    p: ({ children }) => <span>{children}</span>,
                    strong: ({ children }) => (
                      <strong style={{ fontWeight: 700 }}>{children}</strong>
                    ),
                  }}
                >
                  {line}
                </ReactMarkdown>
              </div>
            ))}
          </div>
        </div>
      ) : (
        renderParagraphs(markdown, styles)
      )}
    </div>
  );
};

export default IndexingAssessmentViewerV2;
